import { useState } from "react";
import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";
import { formatViews } from "@/components/feature/PostCard";

const ranges = [
  { id: "all", label: "全站" },
  { id: "hot", label: "热议" },
  { id: "fresh", label: "最新" },
];

export default function RankingSection() {
  const [range, setRange] = useState("all");

  let list = [...posts];
  if (range === "hot") list = list.filter((p) => p.hot);
  if (range === "fresh") list = list.sort((a, b) => b.date.localeCompare(a.date));
  list = list.sort((a, b) => b.views - a.views).slice(0, 7);

  return (
    <section id="ranking" className="w-full px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="热度榜"
        title="大家这周都在看什么"
        desc="依据阅读量与讨论量综合排序，每天更新一次。榜单只反映关注度，不代表任何立场。"
        action={
          <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
            {ranges.map((r) => (
              <button
                key={r.id}
                type="button"
                onClick={() => setRange(r.id)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                  range === r.id
                    ? "bg-background-50 text-foreground-950"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {r.label}
              </button>
            ))}
          </div>
        }
      />

      <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
        {list.map((post, index) => {
          const cat = categories.find((c) => c.id === post.categoryId);
          return (
            <Link
              key={post.id}
              to={`/post/${post.id}`}
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <span
                className={`font-heading text-2xl font-black ${
                  index < 3 ? "text-primary-600" : "text-foreground-300"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {post.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
                    {cat?.name}
                  </span>
                  <span>{post.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(post.views)}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-line shrink-0 text-foreground-400 transition-colors group-hover:text-primary-600"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}